export default __webpack_public_path__ + "static/media/icon_cecim.624364c1.svg";